import React, { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { BsPinMapFill, BsPhone, BsEnvelope } from "react-icons/bs";
import { FaWater, FaSpa, FaPeopleCarry } from "react-icons/fa";
import DonateButton from "../components/Donate";
import Matru1 from "../assets/Matrutirth_Image.jpg";
import Matru2 from "../assets/Matrukund1.jpg";
import Matru3 from "../assets/Matrukund2.jpg";
import { Link } from "react-router-dom";
import Header from "../components/Layout/Header";
import "./Matrukund.css"; // new CSS file specific to Matrukund

const translations = {
  en: {
    header: "MatruTirth – Shree Gurupeeth",
    aboutTitle: "About MatruTirth",
    aboutDesc:
      "In the majestic premises of Shree Gurupeeth, there exists MatruTirth (Shrine pool), a gem of pilgrimages giving the experience of Amrita Tirtha. At the North-East side of Shree Gurupeeth, in 25,000 sqft area, this pool has been built for daily holy baths. To provide power to Sadguru Moredada’s Global-encompassing sevamarg’s activities in the form of divine Shakti (Feminine power) and in memory of Sadguru Moredada’s better half Shankuntalatai More, this MatruTirth has been constructed.",
    features: [
      "Clean and pristine water from Gomukh for holy baths",
      "Water inclusion from Kushavart, Seven Holy rivers of India and Oceans",
      "Continuous availability of hot water, separate arrangements for male and female devotees, 24×7 holy bath with pristine water, and effective for cure of physical, mental and other illnesses."
    ],
    contactTitle: "Contact Info",
    address: "Shree Gurupeeth, Trimbakeshwar, Nashik, Maharashtra, India – 422212",
    phone: "+91 2594 234253 / 54",
    email: "matrutirth@gurupeeth.in",
    gallery: "Gallery",
    view: "View",
    home: "Home"
  },
  mr: {
    header: "मातृतीर्थ – श्री गुरुपीठ",
    aboutTitle: "मातृतीर्थ विषयी",
    aboutDesc:
      "श्री गुरुपीठाच्या भव्य परिसरात मातृतीर्थ (तळे) आहे, जे तीर्थयात्रेचे रत्न आहे आणि अमृततर्थाचा अनुभव देते. श्री गुरुपीठाच्या उत्तर-पूर्व भागात, २५,००० चौ.फु. क्षेत्रात, दररोज पवित्र स्नानासाठी हे तळे बांधले आहे. सद्गुरु मोरेदादांच्या विश्वव्यापी सेवामार्गाच्या उपक्रमांना दैवी शक्ती (स्त्रीशक्ती) स्वरूपात उर्जा देण्यासाठी आणि सद्गुरु मोरेदादांच्या जीवनसाथी शांкутलाताई मोरे यांच्या स्मरणार्थ हे मातृतीर्थ बांधले गेले आहे.",
    features: [
      "पवित्र स्नानासाठी गोमुखातील स्वच्छ आणि निर्मळ पाणी",
      "कुशावर्त, भारतातील सात पवित्र नद्या आणि महासागरांचे पाणी समावेश",
      "गरम पाणी सतत उपलब्ध, पुरुष आणि महिला भक्तांसाठी स्वतंत्र व्यवस्था, २४×७ पवित्र स्नान आणि शारीरिक, मानसिक व अन्य रोगांवर परिणामकारक"
    ],
    contactTitle: "संपर्क माहिती",
    address: "श्री गुरुपीठ, त्रिंबकेश्वर, नाशिक, महाराष्ट्र, भारत – ४२२२१२",
    phone: "+९१ २५९४ २३४२५३ / ५४",
    email: "matrutirth@gurupeeth.in",
    gallery: "गॅलरी",
    view: "पाहा",
    home: "मुख्यपृष्ठ"
  }
};

export default function Matrukund() {
  const { lang } = useContext(LanguageContext);
  const t = translations[lang];

  const images = [Matru1, Matru2, Matru3];

  return (
    <div className="matrukund-page">
      {/* Header + Breadcrumb */}
      <div className="matrukund-header-wrapper">
        <Header /> {/* Hamburger works */}
        <div className="matrukund-header">
          <div className="header-center">
            <div className="breadcrumb">
            <Link to="/">{t.home}</Link>  &gt;  <span>{t.header}</span>
            </div>
            <h1>{t.header}</h1>
          </div>
        </div>
      </div>

      <main className="matrukund-main">
        <div className="info-video-container">
          <div className="matrukund-info-left">
            <h2>{t.aboutTitle}</h2>
            <p>{t.aboutDesc}</p>

            {/* Features */}
            <div className="matrukund-stats">
              {t.features.map((feature, idx) => (
                <div key={idx} className="stat-card">
                  {idx === 0 && <FaWater className="stat-icon" />}
                  {idx === 1 && <FaSpa className="stat-icon" />}
                  {idx === 2 && <FaPeopleCarry className="stat-icon" />}
                  <p>{feature}</p>
                </div>
              ))}
            </div>

            {/* Contact Info */}
            <h3>{t.contactTitle}</h3>
            <div className="contact-info-cards">
              <div className="contact-card">
                <BsPinMapFill className="icon icon-address" />
                <p>{t.address}</p>
              </div>
              <div className="contact-card">
                <BsPhone className="icon icon-phone" />
                <p>{t.phone}</p>
              </div>
              <div className="contact-card">
                <BsEnvelope className="icon icon-email" />
                <p>{t.email}</p>
              </div>
            </div>

            <div className="matrukund-buttons">
              <Link to="/donation">
                <DonateButton />
              </Link>
            </div>
          </div>
        </div>

        {/* Gallery */}
        <section className="matrukund-gallery">
          <h2>{t.gallery}</h2>
          <div className="gallery-grid">
            {images.map((img, i) => (
              <div key={i} className="gallery-item">
                <img src={img} alt={`${t.header} ${i + 1}`} />
                <div className="gallery-overlay">{t.view}</div>
              </div>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}
